// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const nihilego: PokeData = {
  "id": 793,
  "name": "nihilego",
  "height": 12,
  "weight": 555,
  "base_experience": 257,
  "types": [
    PokeType.ROCK,
    PokeType.POISON
  ],
  "api_moves": [
    "pound",
    "headbutt",
    "wrap",
    "acid",
    "constrict",
    "psywave",
    "safeguard",
    "mirror-coat",
    "tickle",
    "toxic-spikes",
    "power-gem",
    "stealth-rock",
    "head-smash",
    "guard-split",
    "power-split",
    "wonder-room",
    "venoshock",
    "acid-spray",
    "clear-smog",
    "venom-drench"
  ],
  "moves": [
    "headbutt",
    "acid",
    "psywave",
    "toxic-spikes",
    "stealth-rock",
    "venom-drench",
    "poison-powder",
    "power-siphon",
    "mortal-gas",
    "purify",
    "stun-spore",
    "rock-tomb",
    "rock-slide"
  ],
  "evolution_chain": {
    "id": 414,
    "item": null,
    "species": [
      {
        "name": "nihilego",
        "order": 793,
        "types": [
          PokeType.ROCK,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 125,
    "ability_power": 154
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
